var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9806 33.7958C23.8581 32.5713 21.9194 32.4693 20.6949 33.5917C19.4704 34.7142 19.3683 36.653 20.4908 37.8775L35.8989 54.6122C36.5112 55.2244 37.2255 55.6326 38.0418 55.6326C38.0418 55.6326 38.0418 55.6326 38.1438 55.6326C38.9602 55.6326 39.7765 55.3264 40.2867 54.7142L79.2663 15.8366C80.4908 14.6122 80.4908 12.6734 79.2663 11.5509C78.0418 10.4285 76.103 10.3264 74.9806 11.5509L38.2459 48.1836L24.9806 33.7958Z",
    fill: "#96D25A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5519 37.9795C76.8172 37.9795 75.4907 39.306 75.4907 41.0407C75.4907 60.0203 59.9805 75.5305 41.0009 75.5305C22.0213 75.5305 6.51112 60.0203 6.51112 41.0407C6.51112 22.0611 22.0213 6.55092 41.0009 6.55092C42.7356 6.55092 44.0621 5.22439 44.0621 3.48969C44.0621 1.755 42.7356 0.428467 41.0009 0.428467C18.654 0.428467 0.388672 18.6938 0.388672 41.0407C0.388672 63.3876 18.654 81.653 41.0009 81.653C63.3479 81.653 81.6132 63.3876 81.6132 41.0407C81.6132 39.306 80.2866 37.9795 78.5519 37.9795Z",
    fill: "#96D25A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.f5a96fa3f31cfdac7ec8baef589bdffa.svg";
export { ForwardRef as ReactComponent };